import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-form-footer-start',
  styles: [
    ':host { align-self: flex-start}'
  ],
  template: '<ng-content />'
})
export class FormFooterStartComponent {}
